export default {
  common: {
    error: "Algo deu errado",
    reload: "Recarregar",
    errorNotification: "Fomos notificados e corrigiremos o mais rápido possível. Se o problema persistir, por favor",
    contactUs: "Entre em contato conosco.",
    language: "Idioma",
    loading: "Carregando...",
    loadingText: "Carregando",
    save: "Salvar",
    savedSuccessfully: "Salvo com Sucesso",
    saving: "Salvando...",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Excluir",
    add: "Adicionar",
    search: "Pesquisar",
    filter: "Filtrar",
    clear: "Limpar",
    preview: "Visualizar",
    default: "Padrão: {{value}}",
    optional: "Opcional",
    required: "Obrigatório",
    noData: "Nenhum dado",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Localizações",
      cities: "Cidades", 
      regions: "Regiões",
      countries: "Países",
      showOnMap: "Mostrar no mapa",
      addLocation: "Adicionar localização"
    },
    welcome: {
      title: "Bem-vindo ao Locations So Super.",
      subtitle: "Selecione uma seção na navegação para começar."
    }
  },

  // Cities section
  cities: {
    title: "Cidades",
    resourceSingular: "cidade",
    resourcePlural: "cidades",
    headings: {
      name: "Nome",
      status: "Status",
      locations: "Localizações", 
      region: "Região",
      country: "País"
    },
    breadcrumbs: {
      cities: "Cidades"
    }
  },

  // Countries section  
  countries: {
    title: "Países",
    resourceSingular: "país", 
    resourcePlural: "países",
    headings: {
      name: "Nome",
      status: "Status",
      locations: "Localizações",
      cities: "Cidades",
      regions: "Regiões"
    },
    breadcrumbs: {
      countries: "Países"
    }
  },

  // Regions section
  regions: {
    title: "Regiões",
    resourceSingular: "região",
    resourcePlural: "regiões", 
    headings: {
      name: "Nome",
      status: "Status",
      locations: "Localizações",
      cities: "Cidades",
      country: "País"
    },
    breadcrumbs: {
      regions: "Regiões"
    }
  },

  // Map section
  map: {
    title: "Mapa",
    breadcrumbs: {
      locations: "Localizações"
    }
  },

  // Import section
  import: {
    title: "Importar CSV",
    breadcrumbs: {
      locations: "Localizações"
    },
    new: {
      title: "Importar localizações por CSV",
      description: "Baixe um modelo CSV de exemplo para ver um exemplo do formato necessário",
      sampleTemplate: "modelo CSV de exemplo",
      uploadAndContinue: "Enviar e continuar",
      abortOnError: "Abortar em caso de erro",
      abortOnErrorHelp: "Se houver um erro, a importação será abortada, exibirá o erro e nenhuma localização será importada.",
      needHelp: "Precisa de ajuda para importar localizações?"
    },
    show: {
      title: "Importação CSV",
      youCanLeavePage: "Você pode sair desta página",
      backgroundMessage: "Sua importação continuará executando em segundo plano",
      importProgress: "Progresso da importação",
      imported: "Importadas",
      suffix: "localizações",
      importLog: "Log da importação",
      cancelImport: "Cancelar importação",
      cancelConfirmation: {
        title: "Cancelar importação",
        message: "Tem certeza de que deseja cancelar este trabalho de importação? Esta ação não pode ser desfeita.",
        note: "Nota: Para trabalhos em andamento, o trabalho precisará ser concluído e será excluído logo após.",
        yesCancel: "Sim, cancelar importação",
        noContinue: "Não, continuar importação"
      },
      report: "Relatório",
      failedLocations: "Localizações com falha",
      uploadAnother: "Enviar outro CSV",
      backToLocations: "Voltar para localizações",
      importSucceeded: "Importação bem-sucedida",
      importFailed: "Importação falhou"
    },
    messages: {
      uploadSuccess: "CSV enviado com sucesso",
      uploadError: "Não foi possível enviar o CSV",
      pending: "A importação ainda não começou",
      inProgress: "Importação em andamento",
      completed: "Importação concluída",
      invalidHeader: "As seguintes colunas são necessárias",
      invalidCsvFile: "Arquivo CSV inválido",
      aborted: "Importação abortada",
      failed: "Importação falhou",
      cancelled: "Importação cancelada"
    },
    errors: {
      csvTooLarge: "CSV é muito grande",
      languageNotEnabled: "O idioma '{{language}}' não está habilitado para esta loja. Por favor, habilite-o em Configurações > Idiomas primeiro.",
      fieldNotTranslatable: "O campo '{{field}}' não é traduzível. Os campos traduzíveis são: {{fields}}",
      locationError: "Localização com slug: {{slug}} - {{error}}",
      planLimit: "Você está no limite do seu plano para localizações"
    }
  },

  // Location form
  location: {
    index: {
      title: "Localizações",
      addLocation: "Adicionar localização",
      import: "Importar",
      noPrioritySet: "Nenhuma prioridade definida",
      published: "Publicado",
      draft: "Rascunho",
      resourceSingular: "localização",
      resourcePlural: "localizações",
      headings: {
        name: "Nome",
        status: "Status", 
        city: "Cidade",
        region: "Região",
        country: "País",
        priority: "Prioridade"
      }
    },
    form: {
      title: "Adicionar localização",
      editTitle: "Editar localização",
      basicInformation: "Informações básicas",
      name: "Nome",
      namePlaceholder: "ex. Tijolos do João",
      nameHelpDefault: "Padrão: {{defaultName}}",
      details: "Detalhes",
      description: "Descrição",
      descriptionPlaceholder: "Conte aos clientes o que torna esta localização especial",
      address: "Endereço",
      addressPlaceholder: "123 Rua Principal, Cidade, País",
      addressLine1: "Linha de endereço 1",
      addressLine2: "Linha de endereço 2",
      postalZipCode: "CEP / Código postal",
      city: "Cidade",
      stateProvinceRegion: "Estado / Província / Região",
      country: "País",
      phone: "Telefone",
      phonePlaceholder: "+55 (11) 1234-5678",
      email: "Email", 
      emailPlaceholder: "loja@exemplo.com",
      website: "Site",
      websitePlaceholder: "https://www.example.com",
      image: "Image",
      imagePlaceholder: "Enter image URL",
      status: "Status",
      statusActive: "Active",
      statusInactive: "Inactive",
      statusDraft: "Draft",
      priority: "Priority",
      priorityHelpText: "Higher priority locations appear first in search results",
      findOnMapButton: "Find on map"
    },
    validation: {
      addressNotFound: "Não foi possível encontrar o endereço",
      createSuccess: "Localização criada com sucesso", 
      updateSuccess: "Localização atualizada com sucesso",
      checkFields: "Por favor, verifique seus campos",
      findOnMap: "Por favor, encontre sua localização no mapa antes de salvar"
    },
    errors: {
      loading: "Erro ao carregar localização"
    },
    actions: {
      save: "Salvar localização",
      delete: "Excluir localização",
      preview: "Visualizar"
    },
    customFields: {
      title: "Campos personalizados",
      noCustomFields: "Nenhum campo personalizado configurado",
      configureFields: "Configurar campos",
      emptyState: "Você ainda não configurou nenhum campo personalizado. Campos personalizados permitem adicionar informações específicas às necessidades do seu negócio."
    },
    openingHours: {
      title: "Horário de funcionamento",
      checkboxLabel: "Esta localização tem horários de abertura e fechamento",
      statusOpen: "Aberto",
      statusOpen24h: "Aberto 24H",
      statusClosed: "Fechado",
      openingTimeLabel: "Horário de abertura",
      closingTimeLabel: "Horário de fechamento",
      days: {
        monday: "Segunda-feira",
        tuesday: "Terça-feira", 
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
        sunday: "Domingo"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Adicionados recentemente",
        recentlyModified: "Modificados recentemente"
      },
      filters: {
        status: "Status",
        taggedWith: "Marcado com",
        locationStatus: "Status da localização",
        noTagsToShow: "Nenhuma tag para mostrar",
        searchPlaceholder: "Buscar"
      },
      bulkActions: {
        setPublished: "Definir como publicado",
        setUnpublished: "Definir como não publicado", 
        setPriority: "Definir prioridade",
        deleteLocations: "Excluir localizações",
        exportCSV: "Exportar como CSV"
      },
      appliedFilters: {
        statusIs: "Status é {{status}}",
        taggedWith: "Marcado com {{tag}}",
        nameIncludes: "Nome inclui {{search}}"
      },
      modals: {
        deleteTitle: "Excluir localizações",
        deleteMessage: "Tem certeza de que deseja excluir {{count}}?",
        deleteMessageAll: "Tem certeza de que deseja excluir todas as localizações?",
        prioritiseTitle: "Priorizar {{count}} localizações",
        prioritiseTitleAll: "Priorizar todas as localizações",
        delete: "Excluir",
        cancel: "Cancelar"
      },
      emptyState: {
        noResultsHeading: "Não foi possível encontrar {{resourcePlural}}",
        noResultsText: "Tente alterar os filtros ou termo de busca",
        noDataHeading: "Adicione uma localização para preencher {{resourcePlural}}",
        addLocation: "Adicionar Localização",
        importFromCSV: "Importar do CSV"
      },
      pagination: {
        label: "Página {{page}} de {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Atualizado com sucesso",
        deletedSuccessfully: "Excluído com sucesso", 
        exportedSuccessfully: "Exportado com sucesso",
        error: "Algo deu errado"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Conteúdo da página",
    editTemplate: "Editar template SEO", 
    pageTitle: "Título",
    pageDescription: "Descrição",
    metaTitle: "Título",
    metaDescription: "Descrição",
    urlHandle: "Identificador da URL",
    searchEnginePreview: "Visualização da listagem do mecanismo de busca",
    editMeta: "Editar Meta",
    previewMeta: "Visualizar Meta",
    loading: "Carregando...",
    editingLocaleHelp: "Editando conteúdo {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Templates SEO",
    breadcrumbs: {
      seoTemplates: "Templates SEO"
    },
    template: {
      title: "Template {{templateName}} - {{locale}}",
      discardChanges: "Descartar alterações"
    },
    form: {
      pageContent: "Conteúdo da página",
      searchEnginePreview: "Visualização da listagem do mecanismo de busca",
      title: "Título",
      description: "Descrição",
      pageTitle: "Título da página",
      metaDescription: "Meta descrição",
      editingLocaleHelp: "Editando traduções {{locale}}. Campos vazios exibirão conteúdo de {{defaultLocale}}.",
      defaultValue: "Padrão: {{value}}"
    },
    language: {
      label: "Idioma",
      defaultHelp: "Este é seu idioma padrão",
      editingHelp: "Editando traduções {{locale}}. Campos vazios mostrarão conteúdo {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Múltiplos idiomas não habilitados",
      enableInSettings: "Habilitar nas Configurações",
      multipleLanguagesInfo: "Para gerenciar templates SEO para múltiplos idiomas, habilite a internacionalização nas suas configurações de idioma. Atualmente mostrando apenas templates {{locale}}."
    },
    badges: {
      errors: "Erros!",
      unsaved: "Não salvo"
    },
    messages: {
      saveSuccess: "Templates SEO salvos com sucesso",
      saveError: "Não foi possível salvar templates",
      error: "Erro..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Informações básicas",
      name: "Nome",
      save: "Salvar",
      saving: "Salvando...",
      cancel: "Cancelar",
      yourLocationsIn: "Suas localizações em {{name}}",
      tableHeadings: {
        name: "Nome",
        status: "Status",
        city: "Cidade",
        region: "Região",
        country: "País"
      },
      resourceName: {
        singular: "localização {{name}}",
        plural: "localizações em {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Mapa",
      tags: "Tags",
      customFields: "Campos personalizados",
      languages: "Idiomas",
      plan: "Plano",
      addTag: "Adicionar tag",
      addField: "Adicionar campo"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Termina em breve"
    },
    common: {
      loading: "Carregando...",
      error: "Erro...",
      breadcrumbs: {
        settings: "Configurações"
      },
      skeleton: {
        customFields: "Campos personalizados",
        addField: "Adicionar campo",
        name: "Nome",
        contentType: "Tipo de conteúdo",
        usedIn: "Usado em",
        field: "Campo",
        fields: "Campos"
      },
      messages: {
        savedSuccessfully: "Configurações {{setting}} salvas com sucesso",
        couldntSave: "Não foi possível salvar configurações {{setting}}"
      }
    },
    map: {
      title: "Mapa",
      messages: {
        savedSuccessfully: "Configurações do mapa salvas com sucesso",
        couldntSave: "Não foi possível salvar configurações"
      },
      mapboxToken: {
        title: "Token Mapbox",
        description: "Digite seu token Mapbox para alimentar seu localizador de lojas",
        label: "Token Mapbox",
        placeholder: "Digite o token aqui para continuar usando seu mapa.",
        placeholderManaged: "Digite o token aqui para continuar usando seu mapa quando você esgotar as cargas gratuitas do mapa.",
        helpText: "Siga nossas instruções para criar uma chave Mapbox, depois cole sua chave acima. Se você tiver problemas, entre em contato para obter assistência.",
        linkInstructions: "instruções para criar uma chave Mapbox",
        linkSupport: "entre em contato para obter assistência"
      },
      managedToken: {
        title: "Cargas do mapa",
        description: "Você tem até {{max}} cargas gratuitas do mapa com um token gerenciado, depois disso você terá que criar seu próprio token."
      },
      appearance: {
        title: "Aparência",
        description: "Altere a aparência do seu mapa"
      },
      mapStyle: {
        title: "Estilo do mapa",
        options: {
          streets: "Ruas",
          outdoors: "Exterior", 
          light: "Claro",
          dark: "Escuro",
          satellite: "Satélite",
          satelliteStreets: "Ruas de Satélite",
          navigationDay: "Navegação Diurna",
          navigationNight: "Navegação Noturna"
        }
      },
      searchBehaviour: {
        title: "Comportamento da busca",
        description: "Controla como os visitantes encontram localizações no seu mapa.",
        geolocateLabel: "Estimar automaticamente a localização do visitante e mostrar lojas próximas",
        geolocateHelp: "Se a geolocalização for bem-sucedida, o mapa se moverá para focar perto do visitante. Se uma localização estimada não puder ser encontrada, o mapa permanecerá na posição inicial.",
        filterBehaviour: {
          title: "Comportamento do filtro",
          all: {
            label: "Todas as tags",
            help: "Para uma localização aparecer nos filtros, ela deve ter todas as tags selecionadas"
          },
          any: {
            label: "Qualquer tag", 
            help: "Para uma localização aparecer nos filtros, ela pode ter qualquer uma das tags selecionadas"
          }
        },
        keepSearchInView: {
          label: "Manter marcador de busca visível",
          help: "Quando os resultados da busca aparecerem, o mapa dará zoom para mostrar todas as localizações correspondentes"
        },
        distanceUnits: {
          title: "Unidades de distância",
          km: "Quilômetros",
          miles: "Milhas"
        },
        maxResults: {
          label: "Máximo de resultados",
          help: "Limitar o número de localizações mostradas nos resultados da busca",
          options: {
            results30: "30 resultados"
          }
        },
        maxDistance: {
          label: "Distância máxima", 
          help: "Mostrar apenas localizações dentro desta distância do ponto de busca",
          options: {
            unlimited: "Ilimitado"
          }
        },
        showLocationNames: {
          label: "Mostrar nomes das localizações nas sugestões",
          help: "Exibir nomes das localizações nas sugestões de busca"
        },
        sortByPriority: {
          label: "Ordenar por prioridade em vez de distância",
          help: "É altamente recomendado definir uma distância máxima (que não seja Ilimitado) se esta caixa estiver marcada. Caso contrário, seus clientes verão localizações distantes que têm alta prioridade listadas acima daquelas que estão a uma distância razoável deles (ou de sua consulta de busca, mais especificamente)."
        }
      },
      searchResults: {
        title: "Resultados da busca",
        description: "Controla como as localizações são retornadas no seu mapa.",
        locationsLabel: "Texto dos resultados da busca",
        locationsHelp: "Texto mostrado acima dos resultados da busca (ex., 'Mostrando 5 localizações')",
        prefixLabel: "Prefixo dos resultados da busca", 
        prefixHelp: "Texto mostrado antes do número de resultados"
      },
      popups: {
        title: "Pop-ups",
        showPopups: {
          label: "Mostrar pop-ups",
          help: "Exibir detalhes da localização quando os visitantes clicarem nos marcadores do mapa"
        }
             },
       whitelabel: {
         title: "Marca própria",
         hideLabel: "Ocultar texto 'Powered by'",
         hideHelp: "Remover nossa marca do seu localizador de lojas"
       }
    },
    languages: {
      title: "Idiomas",
      error: "Erro...",
      messages: {
        savedSuccessfully: "Configurações de idioma salvas com sucesso",
        couldntSave: "Não foi possível salvar configurações de idioma"
      },
      banner: {
        upgradeTitle: "Suporte multi-idioma requer upgrade do plano",
        upgradeAction: "Fazer upgrade para Superest",
        upgradeMessage: "Você ainda pode alterar seu idioma padrão, mas habilitar múltiplos idiomas requer um upgrade.",
        disabledMessage: "Configurações de múltiplos idiomas estão desabilitadas no seu plano atual"
      },
      defaultLanguage: {
        title: "Idioma Padrão", 
        description: "Escolha seu idioma principal em que seu conteúdo será exibido.",
        label: "Idioma padrão",
        help: "Este idioma será usado quando nenhum idioma específico for solicitado"
      },
      internationalization: {
        title: "Internacionalização",
        description: "Habilitar múltiplos idiomas. Alcance mais clientes e melhore seu SEO.",
        enableLabel: "Habilitar múltiplos idiomas",
        enableHelp: "Permitir que clientes visualizem seu localizador de lojas em diferentes idiomas"
      },
      supportedLanguages: {
        title: "Idiomas Suportados Adicionais",
        description: "Selecione idiomas adicionais que você deseja suportar. Depois de habilitar um idioma, você verá a opção de fornecer traduções em todo o aplicativo. Para idiomas suportados, os templates SEO padrão, bem como os temas de variáveis comuns serão gerados automaticamente.",
        defaultLocaleNote: "Este é seu idioma padrão e não pode ser desabilitado",
        shopifyEnabled: {
          label: "Este idioma está habilitado na minha Loja Shopify",
          importantNote: "Importante:",
          description: "Desmarque a caixa acima se este idioma não estiver habilitado e publicado para sua loja Shopify. É recomendado habilitar o idioma para sua loja Shopify primeiro indo em Configurações > Idiomas no seu admin Shopify se você ainda não fez isso para uma experiência mais suave do cliente."
        },
        urlFormats: {
          cleanUrls: "URLs limpas:",
          betterSeo: "Melhor SEO e experiência do usuário",
          queryUrls: "URLs com parâmetros de consulta:",
          considerEnabling: "Considere habilitar no Shopify para URLs melhores"
        },
        preview: {
          button: "Visualizar",
          tooltip: "Visualizar localizador de lojas {{language}}"
        },
        tooltips: {
          noTemplates: "Nenhum template SEO padrão disponível para este idioma. Você pode criar traduções personalizadas facilmente."
        }
      }
    },
    tags: {
      title: "Tags",
      addTag: "Adicionar tag",
      error: "Erro",
      messages: {
        deletedSuccessfully: "Tags excluídas com sucesso",
        couldntDelete: "Tags não puderam ser excluídas",
        savedSuccessfully: "Tag salva com sucesso",
        couldntSave: "Por favor, verifique seus campos",
        tagDeleted: "Tag excluída com sucesso"
      },
      resourceName: {
        singular: "tag",
        plural: "tags"
      },
      filters: {
        anyGroup: "Any group",
        inGroup: "In group",
        tagGroup: "Tag group"
      },
      appliedFilters: {
        inGroup: "In {{group}} group",
        nameContains: "Tag name contains {{query}}"
      },
      bulkActions: {
        deleteTag: "Delete tag",
        deleteTags: "Delete tags"
      },
      form: {
        language: "Idioma",
        title: "Título",
        description: "Descrição",
        group: "Grupo",
        groupPlaceholder: "Selecionar grupo",
        addGroup: "Adicionar",
        editingTranslations: "Editando traduções {{language}}. Campos vazios exibirão conteúdo de {{defaultLanguage}}.",
        defaultValue: "Padrão: {{value}}",
        image: "Imagem",
        imageUrl: "URL da imagem"
      },
      actions: {
        save: "Salvar",
        deleteTag: "Excluir tag"
      },
      new: {
        title: "Adicionar tag",
        messages: {
          createSuccess: "Tag criada com sucesso",
          checkFields: "Por favor, verifique seus campos"
        },
        actions: {
          createTag: "Criar tag"
        }
      }
    },
    customFields: {
      title: "Campos personalizados",
      addField: "Adicionar campo",
      error: "Erro",
      resourceName: {
        singular: "Campo",
        plural: "Campos"
      },
      headings: {
        name: "Nome",
        contentType: "Tipo de conteúdo",
        usedIn: "Usado em"
      },
      emptyState: {
        heading: "Crie e gerencie seus campos personalizados",
        createAction: "Criar campo",
        description: "Use campos personalizados para atributos únicos sobre suas localizações. Esses campos podem ser qualquer coisa, desde perfis sociais até o nome e email do gerente da loja"
      },
      pluralization: {
        location: "localização",
        locations: "localizações"
      },
      form: {
        name: "Nome",
        contentType: "Tipo de Conteúdo",
        key: "Chave",
        keyPrefix: "location.fields.",
        keyHelp: "Use esta chave para acessar o conteúdo {{name}} de uma localização em seus templates liquid.",
        translations: {
          title: "Traduções",
          showTranslations: "Mostrar traduções",
          hideTranslations: "Ocultar traduções",
          description: "Traduções são opcionais. Campos vazios exibirão o nome do campo {{language}}.",
          nameTranslation: "Nome ({{language}})",
          defaultValue: "Padrão: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Campo salvo com sucesso",
        couldntSave: "Campo não pôde ser salvo",
        deletedSuccessfully: "Campo excluído com sucesso",
        couldntDelete: "Campo não pôde ser excluído"
      },
      actions: {
        delete: "Excluir"
      },
      new: {
        title: "Adicionar campo",
        messages: {
          savedSuccessfully: "Campo salvo com sucesso",
          couldntSave: "Campo não pôde ser salvo"
        }
      },
      contentTypes: {
        text: "Texto",
        textArea: "Área de Texto", 
        email: "Email",
        number: "Número",
        phoneNumber: "Número de telefone",
        time: "Hora",
        url: "URL"
      }
    },
    plan: {
      title: "Plano",
      error: "Erro",
      changePlan: "Alterar plano",
      usdPerMonth: "USD / mês",
      sections: {
        yourPlanIncludes: "Seu plano inclui",
        nextBillingDate: "Próxima data de cobrança",
        trial: "Teste"
      },
      banners: {
        planUpdated: "Seu plano foi atualizado",
        thankYouUpgrading: "Obrigado por fazer upgrade!",
        letUsKnow: "Nos avise",
        improvementText: "se há algo que podemos fazer melhor."
      },
      locations: {
        upTo: "Até",
        locations: "localizações",
        unlimited: "Localizações ilimitadas",
        used: "usado",
        ofUsed: "{{used}} de {{max}} usado"
      },
      trial: {
        daysLeft: "{{days}} dias restantes",
        daysUsed: "{{used}} de {{total}} dias usados",
        selectPlan: "Selecionar um plano",
        currentPlan: "Plano Atual",
        trialBadge: "Teste",
        currentBadge: "Atual",
        yourTrialJustStarted: "Seu teste acabou de começar",
        trialEndsAfterToday: "Seu teste termina após hoje",
        trialEndsTomorrow: "Seu teste termina amanhã",
        daysLeftInTrial: "{{days}} dias restantes no seu teste",
        continueAddingLocations: "Continue adicionando localizações após {{date}} selecionando um plano",
        selectPlanToday: "Por favor, selecione um plano hoje para continuar adicionando localizações"
      },
      footer: {
        description: "Gerencie ou altere seu plano Locations So Super. Veja nossos",
        termsOfService: "termos de serviço",
        and: "e",
        privacyPolicy: "política de privacidade"
      },
      features: {
        analytics: {
          title: "Analytics",
          description: "Descubra como as pessoas estão usando suas localizações e onde estão buscando"
        },
        internationalization: {
          title: "Suporte multi-idioma",
          description: "Melhore o SEO e alcance mais clientes em mercados-alvo habilitando múltiplos idiomas"
        },
        customThemes: {
          editLiquid: {
            title: "Editar templates liquid do tema",
            description: "Exiba dados de localização da forma que quiser com acesso ao liquid do tema"
          },
          editStructuredData: {
            title: "Editar dados estruturados do negócio",
            description: "Edite como o Google entende as páginas editando seus dados estruturados"
          }
        }
      },
      edit: {
        title: "Alterar plano",
        allPlansInclude: "Todos os planos acima incluem",
        needingMoreLocations: "Precisa de mais localizações?",
        footerQuestion: "Tem alguma dúvida antes de começar?",
        sendMessage: "envie-nos uma mensagem",
        allFeatures: {
          seoDirectory: {
            title: "Diretório SEO e páginas de destino",
            description: "Crie automaticamente um diretório SEO de todas as suas localizações, cidades e regiões"
          },
          mapPage: {
            title: "Página de mapa com busca e filtro",
            description: "Pesquise e filtre todas as suas localizações em um mapa powered by Mapbox"
          },
          tags: {
            title: "Tags",
            description: "Crie tags com imagens e descrições e as agrupe"
          },
          openingHours: {
            title: "Horário de funcionamento",
            description: "Defina e exiba o horário de funcionamento das suas localizações"
          },
          mapStyles: {
            title: "Estilos de mapa",
            description: "Altere a aparência dos mapas com vários estilos predefinidos"
          },
          customFields: {
            title: "Campos personalizados",
            description: "Adicione qualquer novo campo que desejar, desde links sociais até gerente da loja"
          },
          csvUpload: {
            title: "Upload e exportação com CSV",
            description: "Faça upload e edite suas localizações em massa."
          },
          richSnippets: {
            title: "Rich snippets",
            description: "Ajude o Google a entender melhor as páginas com dados estruturados de negócios locais"
          },
          directionsAndCalls: {
            title: "Direções e chamadas",
            description: "Visitantes podem facilmente obter direções e fazer chamadas para as localizações"
          },
          languageSupport: {
            title: "Suporte a idiomas",
            description: "Altere o idioma padrão para algo diferente do inglês. Templates de tradução fornecidos para 32 idiomas principais para configuração fácil."
          }
        }
      },
      planCard: {
        bestToCustomize: "Melhor para personalizar",
        currentPlan: "Plano atual",
        chooseThisPlan: "Escolher este plano",
        locationsSection: "Localizações",
        featuresSection: "Recursos",
        upTo: "Até",
        locations: "localizações",
        tooltipTooManyLocations: "Você tem muitas localizações e/ou idiomas habilitados para este plano."
      },
      confirmation: {
        error: "Erro ao confirmar plano"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temas",
    currentTheme: {
      title: "Tema atual",
      description: "Este é o tema que os clientes veem quando visitam seu aplicativo de localização."
    },
    themeLibrary: {
      title: "Biblioteca de temas", 
      description: "Gerencie os temas das suas localizações. Adicione e publique temas para alterar a aparência da sua localização online."
    },
    skeleton: {
      currentThemeDescription: "Este é o tema que seus clientes veem quando usam seu aplicativo de localizações."
    },
    modal: {
      overrideTitle: "Substituir tema atual?",
      override: "Substituir",
      cancel: "Cancelar",
      undoWarning: "Esta ação não pode ser desfeita."
    },
    messages: {
      publishSuccess: "Tema publicado com sucesso",
      publishError: "Não foi possível publicar o tema",
      error: "Algo deu errado"
    },
    emptyStates: {
      settings: {
        heading: "Este tema não tem configurações",
        description: "Crie configurações no editor de templates.",
        createSettings: "Criar configurações",
        upgradePlan: "Fazer upgrade do plano",
        upgradeRequired: "Fazer upgrade do plano para criar configurações"
      },
      language: {
        heading: "Este tema não tem termos de idioma",
        description: "Crie termos de idioma no editor de templates.",
        createLanguageTerms: "Criar termos de idioma",
        upgradePlan: "Fazer upgrade do plano",
        upgradeRequired: "Fazer upgrade do plano para criar termos de idioma"
      }
    },
    templates: {
      categories: {
        templates: "Templates",
        schemas: "Esquemas",
        styles: "Estilos",
        liquidReference: "Referência Liquid"
      },
      items: {
        landing: "Página inicial",
        directory: "Diretório",
        country: "País",
        region: "Região",
        city: "Cidade",
        location: "Localização",
        language: "Idioma",
        settings: "Configurações",
        stylesheet: "Folha de estilo"
      },
      errors: {
        errorsInTemplate: "Erros no template",
        error: "Erro"
      },
      badges: {
        errors: "Erros!",
        unsaved: "Não salvo"
      },
      actions: {
        viewTheme: "Visualizar tema",
        discard: "Descartar",
        save: "Salvar"
      }
    },
    language: {
      messages: {
        saveSuccess: "Traduções de idioma do tema salvas com sucesso",
        saveError: "Tema não pôde ser salvo"
      },
      form: {
        language: "Idioma",
        defaultLanguageHelp: "Este é seu idioma padrão",
        translationHelp: "Editando traduções para {{selectedLocale}}. Campos vazios exibirão conteúdo de {{defaultLocale}} (seu idioma padrão)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Múltiplos idiomas não habilitados",
          action: "Habilitar nas Configurações",
          description: "Para gerenciar traduções para múltiplos idiomas, habilite a internacionalização nas suas configurações de idioma. Atualmente mostrando apenas traduções {{locale}}."
        },
        translating: {
          title: "Traduzindo de {{from}} para {{to}}",
          description: "Qualquer campo que você deixar vazio exibirá automaticamente o conteúdo {{defaultLocale}} para seus clientes. Traduza apenas os campos onde você quer conteúdo diferente em {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Acesse os termos de idioma {{category}} no liquid com {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Título",
        description: "Descrição",
        heading: "Cabeçalho",
        subheading: "Subcabeçalho",
        button_text: "Texto do botão",
        link_text: "Texto do link",
        placeholder: "Placeholder",
        label: "Rótulo",
        help_text: "Texto de ajuda",
        error_message: "Mensagem de erro",
        success_message: "Mensagem de sucesso",
        
        // Opening hours
        Monday: "Segunda-feira",
        Tuesday: "Terça-feira",
        Wednesday: "Quarta-feira",
        Thursday: "Quinta-feira",
        Friday: "Sexta-feira",
        Saturday: "Sábado",
        Sunday: "Domingo",
        opening_hours_format: "Formato do horário de funcionamento",
        closes_at_format: "Formato de fechamento",
        opens_at_format: "Formato de abertura",
        opens_on: "Abre em",
        open_24h: "Aberto 24h",
        open: "Aberto",
        closed: "Fechado",
        closes_at: "Fecha às",
        opens_at: "Abre às",
        
        // Map
        search_map: "Buscar no mapa",
        search_area: "Buscar nesta área",
        view_map: "Mapa",
        view_list: "Lista",
        open_filters: "Filtros",
        stores_near_you: "Lojas perto de você",
        header: "Encontre uma Loja!",
        search_placeholder: "Digite um CEP ou endereço...",
        no_listings: "Desculpe, não conseguimos encontrar localizações para sua busca. Tente alterar os filtros ou a localização da busca",
        
        // Directory
        view_directory: "Diretório de Lojas",
        
        // Location
        get_directions: "Direções",
        call: "Ligar",
        view_website: "Site",
        email: "Email",
        opening_hours_header: "Horário de Funcionamento",
        description_header: "Informações",
        phone_number_header: "Telefone",
        address_header: "Endereço",
        tag_groups_to_display: "Grupos de tags para exibir"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Geral",
        navigation: "Navegação",
        forms: "Formulários",
        buttons: "Botões",
        messages: "Mensagens",
        errors: "Erros",
        opening_hours: "Horário de Funcionamento",
        map: "Mapa",
        directory: "Diretório",
        location: "Localização"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema salvo com sucesso",
        saveError: "Tema não pôde ser salvo"
      },
      accessSettings: "Acesse as configurações {{category}} no liquid com {{code}}",
      fields: {
        // Colors
        color_text: "Cor do texto",
        color_text_heading: "Cor do cabeçalho do texto", 
        color_background: "Cor de fundo",
        color_accent: "Cor de destaque",
        color_text_positive: "Cor do texto positivo",
        color_text_negative: "Cor do texto negativo",
        dark_theme: "Tema escuro",
        color_marker: "Cor do marcador",
        color_search_marker: "Cor do marcador de busca",
        
        // Typography
        base_font_size: "Tamanho da fonte base",
        
        // Buttons
        border_radius: "Raio da borda",
        
        // Images
        aspect_ratio: "Proporção",
        fit: "Ajuste",
        
        // Spacing
        page_width: "Largura da página",
        page_width_small: "Largura da página pequena",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobile",
        desktop_vertical_spacing: "Espaçamento vertical desktop",
        mobile_vertical_spacing: "Espaçamento vertical mobile",
        
        // Breakpoints
        breakpoint_xs: "Breakpoint XS",
        breakpoint_sm: "Breakpoint SM",
        breakpoint_md: "Breakpoint MD",
        
        // Map
        search_on_move: "Buscar ao mover",
        scroll_to_zoom: "Rolar para zoom",
        
        // Landing page
        sidebar_width: "Largura da barra lateral",
        sidebar_min_height: "Altura mínima da barra lateral",
        marker_image_src: "Fonte da imagem do marcador",
        show_filter_descriptions: "Mostrar descrições dos filtros",
        
        // Location page
        tag_groups_to_display: "Grupos de tags para exibir",
        tag_groups_to_display_as_icons: "Grupos de tags para exibir como ícones",
        show_related_locations: "Mostrar localizações relacionadas",
        
        // Locations
        hide_regions: "Ocultar regiões"
      },
      categories: {
        colors: "Cores",
        typography: "Tipografia",
        buttons: "Botões",
        images: "Imagens",
        spacing: "Espaçamento",
        breakpoints: "Breakpoints",
        map: "Mapa",
        landing_page: "Página inicial",
        location_page: "Página da localização",
        locations: "Localizações"
      }
    },
    navigation: {
      sublimeTheme: "Tema Sublime",
      settings: "Configurações",
      language: "Idioma",
      templates: "Templates",
      changeTheme: "Alterar tema",
      viewDirectory: "Visualizar diretório",
      viewLandingPage: "Visualizar página inicial"
    },
    card: {
      lastUpdated: "Última atualização",
      view: "Visualizar",
      customize: "Personalizar",
      publish: "Publicar",
      actions: "Ações"
    }
  },

  // Analytics section
  analytics: {
    title: "Analytics",
    timePeriods: {
      last7days: "Últimos 7 dias",
      last30days: "Últimos 30 dias"
    },
    comparison: {
      compareToPrevious: "Comparar com período anterior",
      stopComparing: "Parar de comparar com período anterior"
    },
    sections: {
      searchLocations: "Buscar localizações"
    },
    cards: {
      sessions: "Sessões",
      topSearches: "Principais buscas",
      topLandingPageType: "Tipo de página inicial mais acessada",
      topPageViewsBySession: "Principais visualizações de página por sessão",
      topLocations: "Principais localizações",
      topReferrers: "Principais referenciadores",
      searches: "Buscas",
      topLandingPagesBySession: "Principais páginas iniciais por sessão"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 